import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import ProductEditor from "../product-editor";

const CreateProduct = () => {
  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neues Produkt erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <ProductEditor />
      </div>
    </div>
  );
};

export default CreateProduct;
